import React, { Suspense, lazy } from 'react'
import Common from '../../utils/common';
import $ from "jquery";
const InitLastView = lazy(() => import('./initAfterViewHome'));

export default class Home extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            category: null,
            relations: [],
            build: '',
            activePage: 15
        }

        var param = {};

        if (window.productEnv)//test
        {
            this.state.build = Common.getPage('firstviewhome', param);

        } else //product
        {            
            
            this.state.build = Common.getPage('home', param);
        }
    }
    render() {
        if ($(".se-pre-con").length) {
            $(".se-pre-con").fadeOut("slow");;
        }
        window.html += "<main id='home' merchantcode='"+window.merchantCode +"'>" + this.state.build + "</main>";
        return (
            <main id="home" merchantcode={window.merchantCode}>
                <div dangerouslySetInnerHTML={{ __html: this.state.build }}></div>
                <Suspense fallback={<div>Loading...</div>}>
                    <InitLastView />
                </Suspense>

            </main>

        )

    }

}

